import { render, staticRenderFns } from "./PromActivityList.vue?vue&type=template&id=63d3a113&scoped=true"
import script from "./PromActivityList.vue?vue&type=script&lang=js"
export * from "./PromActivityList.vue?vue&type=script&lang=js"
import style0 from "./PromActivityList.vue?vue&type=style&index=0&id=63d3a113&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d3a113",
  null
  
)

export default component.exports